/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './Modal.module.css';

const Modal = ({ children, setShowModal, isLogin }) => (
  <div className={`${styles.CustomModal} ${styles['CustomModal--backdrop']}`}>
    <div className={styles.CustomModal__container}>
      {isLogin ? null : (
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        <div
          className={styles['CustomModal__icon-container']}
          onClick={() => setShowModal((p) => !p)}
        >
          <i className={`material-icons ${styles.CustomModal__icon}`}>close</i>
        </div>
      )}
      {children}
    </div>
  </div>
);

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  isLogin: PropTypes.node.isRequired,
  setShowModal: PropTypes.node.isRequired,
};

export default Modal;
